import type { MobileStoreSection } from "@/components/patterns/mobileStoreNavigationTypes"

const mobileStoreRouteSections: Array<{
  section: MobileStoreSection
  matches: (pathname: string) => boolean
}> = [
  { section: "favorites", matches: (pathname) => pathname.startsWith("/profile/favorites") },
  { section: "account", matches: (pathname) => pathname.startsWith("/profile") },
  { section: "cart", matches: (pathname) => pathname === "/cart" },
  {
    section: "catalog",
    matches: (pathname) =>
      ["/category", "/collections", "/search", "/product", "/ssp"].some(
        (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
      ),
  },
  { section: "home", matches: (pathname) => pathname === "/" },
]

export const getMobileStoreSection = (pathname: string): MobileStoreSection | null =>
  mobileStoreRouteSections.find(({ matches }) => matches(pathname))?.section ?? null
